import FBody from '@/plugins/form/FBody';
import FTime from '@/plugins/form/FTime';
import FNumber from '@/plugins/form/FNumber';

export default class extends FBody {
  duration = new FNumber({
    label: 'Продолжительность',
    right: 'дней',
    btn: 'none',
  });

  time = new FTime({
    label: 'Время начала',
  });

  quota = new FNumber({
    label: 'Квота мест',
    min: 1,
  });

  constructor(props = {}) {
    super(props);
    this.tour = props.parent;
    this.setItemDuration();
    this.setItemTime();
    this.setItemQuota();
  }

  get data() {
    const data = super.data;
    return {
      Duration: data.duration || 0,
      DefaultBeginTime: this.time.getMilliseconds() || 0,
      DefaultPeopleQuota: data.quota || 1,
    };
  }

  set data(data) {
    this.duration.set(data?.Duration || 0);
    this.time.setMilliseconds(data?.DefaultBeginTime || 0);
    this.quota.set(data?.DefaultPeopleQuota || 1);
  }

  set(value = {}) {
    this.duration.set(value.duration || 0);
    this.time.set(value.time || '');
    this.quota.set(value.quota || 1);
    return this;
  }

  setItemDuration() {
    this.setItem('duration', this.duration);
  }

  setItemTime() {
    this.setItem('time', this.time);
  }

  setItemQuota() {
    this.setItem('quota', this.quota);
  }
}
